import { defineStore } from 'pinia';

export const usePageContextStore = defineStore('pageContext', {
  state: () => ({
    pageContext: {
      currentPageName: '',
      currentPageInstruction: '',
      availablePageData: '',
    },
  }),

  actions: {
    setPageContext(pageName, pageInstruction, data) {
      this.pageContext.currentPageName = pageName;
      this.pageContext.currentPageInstruction = pageInstruction;
      this.pageContext.availablePageData = data;
    },
  },

  getters: {
    getPageContext(state) {
      return state.pageContext;
    },
  },
});
